import React, { useState, useEffect} from "react";
import '../styles/LoadMap.css'
import { data } from './Board.js';
import { clearAll } from './Board.js';
import maps from "../data/maps.js";
import ReactGA from 'react-ga4';

ReactGA.initialize('G-7HQ6K7SGK5'); //primal nus latest -GA
const math = require('mathjs');

let { allMaps } = maps;


function LoadMap(props) {
    const [selectedOption, setSelectedOption] = useState(props.mapLoaded);

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
        ReactGA.event({
            category: 'Map Selector',
            action: 'Click',
            label: `${event.target.value} Map is Loaded`
          });
        if (event.target.value === "maze-32-32-4.map") {
            data.paused = true;
            setTimeout(() => {
                clearAll();
                data.map_loaded=event.target.value;
                data.size = 32;
                data.goals = math.zeros(32, 32);
                data.state = allMaps.maze_32_32_4;
            }, 500);

        } else if (event.target.value === "maze-32-32-2.map") {
            data.paused = true;
            setTimeout(() => {
                clearAll();
                data.map_loaded=event.target.value;
                data.size = 32;
                data.goals = math.zeros(32, 32);
                data.state = allMaps.maze_32_32_2;
            }, 500);

        } else if (event.target.value === "room-32-32-4.map") {
            data.paused = true;
            setTimeout(() => {
                clearAll();
                data.map_loaded=event.target.value;
                data.size = 32;
                data.goals = math.zeros(32, 32);
                data.state = allMaps.room_32_32_4;
            }, 500);
        } else if (event.target.value === "") {
            data.paused = true;
            setTimeout(() => {
                clearAll();
                data.map_loaded="";
                data.size = 10;
                data.goals = math.zeros(10, 10);
                data.state = math.zeros(10, 10);
            }, 500);
        }else if (event.target.value === "empty-10-10.map") {
            data.paused = true;
            setTimeout(() => {
                clearAll();
                data.map_loaded=event.target.value;
                data.size = 10;
                data.goals = math.zeros(10, 10);
                data.state = allMaps.empty_10_10;
            }, 500);
        }else if (event.target.value === "random-10-10.map") {
            data.paused = true;
            setTimeout(() => {
                clearAll();
                data.map_loaded=event.target.value;
                data.size = 10;
                data.goals = math.zeros(10, 10);
                data.state = allMaps.random_10_10;
            }, 500);
        }
    };

    useEffect(() => {
        console.log("Updating loaded map....");
        setSelectedOption(props.mapLoaded);
    }, [props.mapLoaded]);

    return (
        <div className="maploader-container">
            <select className="btn-primary maploader-selector" value={selectedOption} onChange={handleChange}>
                <option value="">Choose A Map</option>
                <option value="empty-10-10.map">empty-10-10.map</option>
                <option value="random-10-10.map">random-10-10.map</option>
                {/* <option value="maze-32-32-4.map">maze-32-32-4.map</option> */}
                {/* <option value="maze-32-32-2.map">maze-32-32-2.map</option> */}
                <option value="room-32-32-4.map">room-32-32-4.map</option>
            </select>
        </div>
    );
}

export default LoadMap;